import { render } from "./S132675.vue?vue&type=template&id=cd208d1a"
const script = {}
script.render = render

export default script